import { countryReducerConstant } from "../../constants";
import { countryService } from "../../services";
import { success } from "./utilities";

const {
  GET_ALL_COUNTRIES,
  GET_ALL_STATES,
  GET_ALL_CITIES,
  RESET_CITIES,
  RESET_STATES,
  ALL_LANGUAGES,
} = countryReducerConstant;

const getAllCountries = () => (dispatch) => {
  countryService.getAllCountries().then(
    (response) => dispatch(success(response.data, GET_ALL_COUNTRIES)),
    (error) => console.error(error)
  );
};
const getAllStates = (countryId) => (dispatch) => {
  countryService.getAllStates(countryId).then(
    (response) => dispatch(success(response.data, GET_ALL_STATES)),
    (error) => console.error(error)
  );
};
const getAllCities = (stateId) => (dispatch) => {
  countryService.getAllCities(stateId).then(
    (response) => dispatch(success(response.data, GET_ALL_CITIES)),
    (error) => console.error(error)
  );
};

const resetStates = () => (dispatch) => {
  dispatch(success({}, RESET_STATES));
};
const resetCities = () => (dispatch) => {
  dispatch(success({}, RESET_CITIES));
};

const getAllLanguages = () => (dispatch) => {
  countryService.getAllLanguages().then(
    (response) => dispatch(success(response.data, ALL_LANGUAGES)),
    (error) => console.error(error)
  );
};

export const countryAction = {
  getAllCities,
  getAllCountries,
  getAllStates,
  resetStates,
  resetCities,
  getAllLanguages,
};
